(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["nouveau-chat"] = factory();
	else
		root["nouveau-chat"] = factory();
})(globalThis, () => {
return 